import classNames from 'classnames';
import { useMemo } from 'react';
import { getGrafanaEmbedURL } from '@Features/DashboardWidgets/utils/getGrafanaEmbedUrl';

import { useAppSelector } from '@Hooks/index';
import { currentToken } from '@Store/selectors/authSelector';

import commonStyle from '../../common-desktop-styles.module.css';
import styles from './component-styles.module.css';

const TodaySummaryDesktop: React.FC = () => {
  const authToken = useAppSelector(currentToken);

  const grafanaURL = useMemo(
    // Grafana desktop widget has id = 1
    () => getGrafanaEmbedURL('1', authToken),
    [authToken]
  );

  return (
    <div
      className={classNames(
        commonStyle.infoBlock,
        'trojan-glassphormism-box trojan-glassphormism-box-shadow'
      )}
    >
      <div className={commonStyle.caption}>Today&apos;s Summary</div>
      <div className={styles.summaryContent}>
        <iframe
          src={grafanaURL}
          className={commonStyle.iframe}
          title="Today Summary Desktop"
        />
      </div>
    </div>
  );
};

export default TodaySummaryDesktop;
